import React from 'react';
import { useSelector } from "react-redux";
import { AppState } from "../../store/root.reducer";
import { Navigate, Outlet } from "react-router-dom";
import { useAutoLogin } from "../../hooks/useAutoLogin";
import { hasValidStoredAccessToken } from "../../utils/authToken";
import { hasAdminCapability, hasEdmCuratorCapability, hasStrictAdminCapability } from "../../utils/userAccess";

const renderGuard = (
    user: any,
    loading: boolean,
    canBootstrapFromToken: boolean,
    isAllowed: (candidate: any) => boolean
) => {
    if (!user && (loading || canBootstrapFromToken)) {
        return <div>Authenticating...</div>;
    }

    if (!user) {
        return <Navigate to="/" replace />;
    }

    if (!isAllowed(user)) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export const AdminRoutes = () => {
    const autoLogin = useAutoLogin();
    const { user, loading } = useSelector((state: AppState) => state.auth);
    const triedRef = React.useRef(false);
    const canBootstrapFromToken = !user && hasValidStoredAccessToken();

    React.useEffect(() => {
        if (user) {
            triedRef.current = false;
            return;
        }

        if (!triedRef.current) {
            triedRef.current = true;
            autoLogin(false);
        }
    }, [user, autoLogin]);

    return renderGuard(user, loading, canBootstrapFromToken, hasAdminCapability);
};

export const AdminEdmRoutes = () => {
    const autoLogin = useAutoLogin();
    const { user, loading } = useSelector((state: AppState) => state.auth);
    const triedRef = React.useRef(false);
    const canBootstrapFromToken = !user && hasValidStoredAccessToken();

    React.useEffect(() => {
        if (user) {
            triedRef.current = false;
            return;
        }

        if (!triedRef.current) {
            triedRef.current = true;
            autoLogin(false);
        }
    }, [user, autoLogin]);

    return renderGuard(user, loading, canBootstrapFromToken, hasEdmCuratorCapability);
};

export const StrictAdminRoutes = () => {
    const autoLogin = useAutoLogin();
    const { user, loading } = useSelector((state: AppState) => state.auth);
    const triedRef = React.useRef(false);
    const canBootstrapFromToken = !user && hasValidStoredAccessToken();

    React.useEffect(() => {
        if (user) {
            triedRef.current = false;
            return;
        }

        if (!triedRef.current) {
            triedRef.current = true;
            autoLogin(false);
        }
    }, [user, autoLogin]);

    return renderGuard(user, loading, canBootstrapFromToken, hasStrictAdminCapability);
};
